/**
 * The vendor behind every tenant app — the ONE place the shell's own name lives.
 * Drawn only where a tenant has no identity of its own (`identity: "metaship"`,
 * the interface's literal for "the vendor's product line"), in the "Powered by"
 * credit, and as the neutral fallback before a tenant resolves. A white-label
 * app never shows it (tenant/branding.ts `hasOwnIdentity`).
 */
export const VENDOR_NAME = "Pinksy";
